import './QRCode.scss';

import React from 'react';
import { formatText } from 'core/i18n';
import { createIdentificationQRPath } from 'utilities/qrPaths';

export const QRCode = () => (
    <div className="qr-videoselfie">
        <img src={createIdentificationQRPath()} alt="qr-code" />
        <div className="qr-videoselfie qr-videoselfie__text">
            <p className="qr-videoselfie__text--title">{formatText('identification-betterExperienceQR')}</p>
            <p className="qr-videoselfie__text--subtitle">{formatText('identification-scanQR')}</p>
        </div>
    </div>
);
